import { render, staticRenderFns } from "./new-trainee-public-info.vue?vue&type=template&id=98fff0e4&scoped=true"
import script from "./new-trainee-public-info.vue?vue&type=script&lang=js"
export * from "./new-trainee-public-info.vue?vue&type=script&lang=js"
import style0 from "./new-trainee-public-info.vue?vue&type=style&index=0&id=98fff0e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fff0e4",
  null
  
)

export default component.exports